import { CLEAR } from 'redux/modules/search-and-browse/actions/types';

export const clearProducts = () => ({
  type: CLEAR,
});
